import { render, staticRenderFns } from "./editRoom.vue?vue&type=template&id=2318079b"
import script from "./editRoom.vue?vue&type=script&lang=js"
export * from "./editRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports